import { render, staticRenderFns } from "./config.vue?vue&type=template&id=ee2ae344&scoped=true&"
import script from "./config.vue?vue&type=script&lang=js&"
export * from "./config.vue?vue&type=script&lang=js&"
import style0 from "./config.vue?vue&type=style&index=0&id=ee2ae344&prod&lang=less&scoped=true&"
import style1 from "./config.vue?vue&type=style&index=1&id=ee2ae344&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../yiweb/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee2ae344",
  null
  
)

export default component.exports